import JsCookie from "js-cookie";

import {
  SAVE_SETTINGS_STARTED,
  SAVE_SETTINGS_SUCCESS,
  SAVE_SETTINGS_FAILURE,
} from "../constants/auth.constant";
import { API_URL } from "../constants";
import { COOKIE_REGION_ID, COOKIE_LANG_ID } from "../constants/cookie.constant";

import { ajaxInstance } from "../axiosRetryAgent";

export const saveSettings = (data) => {
  const { userId, regionId, langNum } = data;
  return (dispatch) => {
    dispatch(saveSettingsStarted());
    ajaxInstance()
      .post(`${API_URL}Home/SaveUserPreference`, data, {
        params: {
          userId: userId,
          regionId: JsCookie.get(COOKIE_REGION_ID)
          ? JsCookie.get(COOKIE_REGION_ID)
          : regionId,
          langNum: langNum,
        },
      })
      .then((res) => {
        JsCookie.set(COOKIE_REGION_ID, regionId);
        JsCookie.set(COOKIE_LANG_ID, langNum);
        window.location.reload();
        dispatch(saveSettingsSuccess(res.data));
      })
      .catch((err) => {
        dispatch(saveSettingsFailure(err.message));
      });
  };
};

const saveSettingsSuccess = (saveSettingsInfo) => ({
  type: SAVE_SETTINGS_SUCCESS,
  payload: {
    ...saveSettingsInfo,
  },
});

const saveSettingsStarted = () => ({
  type: SAVE_SETTINGS_STARTED,
});

const saveSettingsFailure = (error) => ({
  type: SAVE_SETTINGS_FAILURE,
  payload: {
    error,
  },
});
